import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonTypeDirectiveDirective } from '@x/ecommerce-shop/app/core/utils/directives/button-type.directive';
import { OverlayResponsiveHeightDirective } from '@x/ecommerce-shop/app/core/utils/directives/overlay-responsive-height.directive';
import { OrderByPipe } from '@x/ecommerce-shop/app/core/utils/pipes/order-by.pipe';
import { ButtonLoadingDirective } from './directives/button-loading.directive';
import { ButtonResponsiveDirective } from './directives/button-responsive.directive';
import { ButtonSizeDirective } from './directives/button-size.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { CopyTextDirective } from './directives/copy-text.directive';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { KeyboardActionDirective } from './directives/keyboard-action.directive';
import { MatFieldAppearanceDirective } from './directives/mat-field-appearance.directive';
import { RemoveSpacesPipe } from './pipes/remove-spaces.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { TrackByIndexPipe } from './pipes/track-by-index.pipe';
import { TrackByPipe } from './pipes/track-by.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ButtonLoadingDirective,
    ButtonSizeDirective,
    ClickOutsideDirective,
    CopyTextDirective,
    DebounceClickDirective,
    ButtonTypeDirectiveDirective,
    KeyboardActionDirective,
    OrderByPipe,
    SafePipe,
    ButtonResponsiveDirective,
    MatFieldAppearanceDirective,
    OverlayResponsiveHeightDirective,
    OrderByPipe,
    SafePipe,
    RemoveSpacesPipe,
    TrackByPipe,
    TrackByIndexPipe,
  ],
  exports: [
    ButtonLoadingDirective,
    ButtonSizeDirective,
    ClickOutsideDirective,
    CopyTextDirective,
    DebounceClickDirective,
    ButtonTypeDirectiveDirective,
    ButtonResponsiveDirective,
    KeyboardActionDirective,
    MatFieldAppearanceDirective,
    OverlayResponsiveHeightDirective,
    OrderByPipe,
    SafePipe,
    RemoveSpacesPipe,
    TrackByPipe,
    TrackByIndexPipe,
  ],
})
export class UtilsModule {}
